<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="font-weight: bold;"><i class="el-icon-trophy text-blue" style="margin-right: 5px;"></i>月排行 (Top 10)</span>
      <div style="float: right;">
        <el-date-picker
          v-model="date"
          type="month"
          placeholder="选择月份"
          size="small"
          style="width: 140px;"
          :clearable="false"
          @change="fetchData">
        </el-date-picker>
      </div>
    </div>

    <el-table :data="rankingList" v-loading="loading" style="width: 100%" stripe :cell-style="{padding: '7px 0'}">
      <el-table-column label="排名" width="80" align="center">
        <template slot-scope="scope">
          <div class="rank-badge" :class="'rank-' + scope.row.rank" v-if="scope.row.rank <= 3">{{ scope.row.rank }}</div>
          <span v-else>{{ scope.row.rank }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="employeeName" label="员工姓名" align="center"></el-table-column>
      <el-table-column prop="traffic" label="流量" align="center"></el-table-column>
      <el-table-column prop="completed" label="成交数" align="center">
        <template slot-scope="scope">
          <span style="font-weight: bold; color: #409EFF;">{{ scope.row.completed }}</span>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
export default {
  name: 'MonthlyRanking',
  data () {
    return {
      date: new Date(),
      loading: false,
      rankingList: []
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      this.loading = true
      try {
        const year = this.date.getFullYear()
        const month = this.date.getMonth() + 1

        const { data: res } = await this.$http.get('zhaoshang/zhuanyuan/monthlyRanking', {
          params: { year, month }
        })

        if (res.meta.status === 200) {
          this.rankingList = res.data.ranking
        } else {
          this.$message.error(res.meta.msg)
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取月排行数据失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.text-blue { color: #409EFF; }
.rank-badge {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  color: #fff;
  font-weight: bold;
  margin: 0 auto;
}
.rank-1 {
  background-color: #f56c6c;
}
.rank-2 {
  background-color: #e6a23c;
}
.rank-3 {
  background-color: #409EFF;
}
</style>
